export const logChatGPTPromptDebug = ({
  allowedModels,
  enhancedData,
  excelData,
  filters,
  prompt,
  reportType,
  validation,
}) => {
  const timestamp = new Date().toISOString();
  const debugPayload = {
    timestamp,
    reportType,
    filters,
    validation,
    promptLength: prompt?.length || 0,
    prompt,
    userMessageBody: { role: "user", content: prompt },
    dataSummary: {
      reportContext: enhancedData?.reportContext || null,
      customerContext: enhancedData?.customerContext || null,
      normalizedFinancialData: enhancedData?.normalizedFinancialData || null,
      metadata: enhancedData?.metadata || null,
      excelDataPreview: Array.isArray(excelData)
        ? { rowsCount: excelData.length, firstRows: excelData.slice(0, 3) }
        : excelData || null,
    },
    assistantConfig: {
      // `AssistantId` لم يعد يصل من الخادم: م3.2 أخرج المفتاح ومعرّف الـ Assistant
      // من ردّ /client/reports، وAssistants API نفسه يُزال في 26/8/2026.
      // البديل هوية النموذج الحقيقية، وهي ما يفيد فعلاً عند تشخيص شكوى.
      modelId: allowedModels?.Id ?? null,
      modelName: allowedModels?.Name || "",
      provider: allowedModels?.Provider || "",
      temperature:
        typeof allowedModels?.Temperature === "number"
          ? allowedModels.Temperature
          : 0,
      modelName: allowedModels?.ModelName || allowedModels?.Name || null,
    },
  };
console.log(allowedModels)
  if (typeof window !== "undefined") {
    window.__LAST_GPT_ANALYSIS_REQUEST__ = debugPayload;
  }

  console.groupCollapsed(`[AI Prompt Debug] ${reportType || "unknown"} | ${timestamp}`);
  console.log("Prompt metadata:", {
    reportType,
    filters,
    validation,
    assistantConfig: debugPayload.assistantConfig,
    promptLength: debugPayload.promptLength,
  });
  console.log("Report context sent to AI:", debugPayload.dataSummary.reportContext);
  console.log("Customer context sent to AI:", debugPayload.dataSummary.customerContext);
  console.log("Normalized financial data sent to AI:", debugPayload.dataSummary.normalizedFinancialData);
  console.log("Prompt body:", prompt);
  console.log("Saved latest request on window.__LAST_GPT_ANALYSIS_REQUEST__");
  console.groupEnd();
};

export const logChatGPTResponseDebug = ({
  parsedResponse,
  rawResponse,
  reportType,
  validation,
  errorMessage = null,
}) => {
  const timestamp = new Date().toISOString();
  const debugPayload = {
    timestamp,
    reportType,
    validation,
    errorMessage,
    rawResponseLength: rawResponse?.length || 0,
    rawResponsePreview: rawResponse?.slice(0, 2000) || "",
    rawResponse: rawResponse || "",
    parsedResponse: parsedResponse || null,
    responseValidation: parsedResponse?.validation || null,
    extractedReport: parsedResponse?.report || null,
  };

  if (typeof window !== "undefined") {
    window.__LAST_GPT_ANALYSIS_RESPONSE__ = debugPayload;
  }

  console.groupCollapsed(`[AI Response Debug] ${reportType || "unknown"} | ${timestamp}`);
  console.log("Response metadata:", {
    reportType,
    validation,
    errorMessage,
    rawResponseLength: debugPayload.rawResponseLength,
  });
  console.log("Raw GPT response:", debugPayload.rawResponse);
  console.log("Parsed GPT response:", debugPayload.parsedResponse);
  console.log("Extracted report:", debugPayload.extractedReport);
  console.log("Saved latest response on window.__LAST_GPT_ANALYSIS_RESPONSE__");
  console.groupEnd();
};
